import IBMPlexSansRegular from '../assets/fonts/IBMPlexSans-Regular.ttf';
import IBMPlexSansSemiBold from '../assets/fonts/IBMPlexSans-SemiBold.ttf';
import IBMPlexSansMedium from '../assets/fonts/IBMPlexSans-Medium.ttf';

import * as colors from './colors';

const primaryFont = '"IBM Plex Sans", sans-serif';

const FONT_WEIGHTS = {
    REGULAR: 400,
    MEDIUM: 500,
    SEMI_BOLD: 600,
};

export const fontFace = {
    regular: {
        fontFamily: primaryFont,
        src: `url(${IBMPlexSansRegular})`,
    },
    bold: {
        fontFamily: primaryFont,
        src: `url(${IBMPlexSansSemiBold})`,
        fontWeight: 'bold',
    },
    ibmRegular: {
        fontFamily: 'IBM Plex Sans',
        src: `url(${IBMPlexSansRegular}) format('truetype')`,
        fontWeight: FONT_WEIGHTS.REGULAR,
        fontStyle: 'normal',
    },
    ibmMedium: {
        fontFamily: 'IBM Plex Sans',
        src: `url(${IBMPlexSansMedium}) format('truetype')`,
        fontWeight: FONT_WEIGHTS.MEDIUM,
        fontStyle: 'normal',
    },
    ibmSemiBold: {
        fontFamily: 'IBM Plex Sans',
        src: `url(${IBMPlexSansSemiBold}) format('truetype')`,
        fontWeight: FONT_WEIGHTS.SEMI_BOLD,
        fontStyle: 'normal',
    },
};

export const heading = {
    _1: {
        fontSize: '4.8rem',
        lineHeight: '6rem',
        fontWeight: FONT_WEIGHTS.SEMI_BOLD,
        fontFamily: primaryFont,
        color: colors.prussianBlue,
    },
    _2: {
        fontSize: '3.6rem',
        lineHeight: '4.4rem',
        fontWeight: FONT_WEIGHTS.SEMI_BOLD,
        fontFamily: primaryFont,
        color: colors.prussianBlue,
    },
    _3: {
        fontSize: '2.4rem',
        lineHeight: '3.2rem',
        fontWeight: FONT_WEIGHTS.SEMI_BOLD,
        fontFamily: primaryFont,
        color: colors.prussianBlue,
    },
    _4: {
        fontSize: '2rem',
        lineHeight: '2.8rem',
        fontWeight: FONT_WEIGHTS.SEMI_BOLD,
        fontFamily: primaryFont,
        color: colors.prussianBlue,
    },
    _5: {
        fontSize: '1.8rem',
        lineHeight: '2.4rem',
        fontWeight: FONT_WEIGHTS.SEMI_BOLD,
        fontFamily: primaryFont,
        color: colors.prussianBlue,
    },
};

export const callout = {
    _1: {
        regular: {
            fontFamily: primaryFont,
            fontSize: '1.6rem',
            lineHeight: '2.2rem',
            color: colors.prussianBlue,
        },
        bold: {
            fontSize: '1.6rem',
            lineHeight: '2.2rem',
            fontFamily: primaryFont,
            fontWeight: FONT_WEIGHTS.SEMI_BOLD,
            color: colors.prussianBlue,
        },
    },
    _2: {
        regular: {
            fontFamily: primaryFont,
            fontSize: '1.3rem',
            lineHeight: '1.8rem',
            color: colors.prussianBlue,
        },
        bold: {
            fontSize: '1.3rem',
            lineHeight: '1.8rem',
            fontFamily: primaryFont,
            fontWeight: FONT_WEIGHTS.SEMI_BOLD,
            color: colors.prussianBlue,
        },
    },
};

export const subHeadline = {
    regular: {
        fontFamily: primaryFont,
        fontSize: '1.4rem',
        lineHeight: '2.1rem',
        color: colors.prussianBlue,
    },
    bold: {
        fontFamily: primaryFont,
        fontSize: '1.4rem',
        lineHeight: '2.1rem',
        color: colors.prussianBlue,
        fontWeight: FONT_WEIGHTS.SEMI_BOLD,
    },
};

export const body = {
    _1: {
        regular: {
            fontSize: '1.6rem',
            lineHeight: '2.4rem',
            fontWeight: FONT_WEIGHTS.MEDIUM,
            fontFamily: primaryFont,
        },
        bold: {
            fontSize: '1.6rem',
            lineHeight: '2.4rem',
            fontFamily: primaryFont,
            fontWeight: FONT_WEIGHTS.SEMI_BOLD,
        },
    },
    _2: {
        regular: {
            fontSize: '1.4rem',
            lineHeight: '2.0rem',
            fontWeight: FONT_WEIGHTS.REGULAR,
            fontFamily: primaryFont,
        },
        bold: {
            fontSize: '1.4rem',
            lineHeight: '2.0rem',
            fontFamily: primaryFont,
            fontWeight: FONT_WEIGHTS.MEDIUM,
        },
    },
};

export const footnote = {
    regular: {
        fontSize: '1.3rem',
        lineHeight: '1.8rem',
        fontFamily: primaryFont,
        fontWeight: FONT_WEIGHTS.REGULAR,
    },
    bold: {
        fontSize: '1.3rem',
        lineHeight: '1.8rem',
        fontWeight: FONT_WEIGHTS.MEDIUM,
        fontFamily: primaryFont,
    },
    link: {
        fontFamily: primaryFont,
        fontWeight: FONT_WEIGHTS.MEDIUM,
        fontSize: '1.3rem',
        lineHeight: '1.8rem',
        textDecoration: 'underline',
    },
};

export const caption = {
    _1: {
        regular: {
            fontSize: '1.2rem',
            lineHeight: '1.6rem',
            fontWeight: FONT_WEIGHTS.REGULAR,
            fontFamily: primaryFont,
        },
        bold: {
            fontSize: '1.2rem',
            lineHeight: '1.6rem',
            fontWeight: FONT_WEIGHTS.MEDIUM,
            fontFamily: primaryFont,
        },
    },
    _2: {
        regular: {
            fontSize: '1.1rem',
            lineHeight: '1.4rem',
            fontWeight: FONT_WEIGHTS.REGULAR,
            fontFamily: primaryFont,
        },
        bold: {
            fontSize: '1.1rem',
            lineHeight: '1.4rem',
            fontWeight: FONT_WEIGHTS.MEDIUM,
            fontFamily: primaryFont,
        },
        heavy: {
            fontSize: '1.1rem',
            lineHeight: '1.4rem',
            fontWeight: FONT_WEIGHTS.SEMI_BOLD,
            fontFamily: primaryFont,
        },
    },
};
